/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const TaskStatusesListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled'),
  "taskCount": zod.number()
}).strict()
export const TaskStatusesListResponse = zod.array(TaskStatusesListResponseItem)

export const taskStatusesCreateBodyNameMax = 40;



export const TaskStatusesCreateBody = zod.object({
  "name": zod.string().min(1).max(taskStatusesCreateBodyNameMax),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).optional().describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal')
})

export const TaskStatusesCreateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled'),
  "taskCount": zod.number()
}).strict()
export const TaskStatusesCreateResponse = zod.array(TaskStatusesCreateResponseItem)

export const TaskStatusesPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the status.')
})

export const taskStatusesPartialUpdateBodyNameMax = 40;



export const TaskStatusesPartialUpdateBody = zod.object({
  "name": zod.string().min(1).max(taskStatusesPartialUpdateBodyNameMax).optional(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).optional().describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal')
})

export const TaskStatusesPartialUpdateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled'),
  "taskCount": zod.number()
}).strict()
export const TaskStatusesPartialUpdateResponse = zod.array(TaskStatusesPartialUpdateResponseItem)

export const TaskStatusesArchiveCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the status.')
})

export const TaskStatusesArchiveCreateBody = zod.object({
  "moveToId": zod.string().uuid().nullish()
})

export const TaskStatusesArchiveCreateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled'),
  "taskCount": zod.number()
}).strict()
export const TaskStatusesArchiveCreateResponse = zod.array(TaskStatusesArchiveCreateResponseItem)

export const TaskStatusesReorderCreateBody = zod.object({
  "ids": zod.array(zod.string().uuid())
})

export const TaskStatusesReorderCreateResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled'),
  "taskCount": zod.number()
}).strict()
export const TaskStatusesReorderCreateResponse = zod.array(TaskStatusesReorderCreateResponseItem)

